module.exports = __webpack_public_path__ + "static/media/c80-connect.057a796b.png";